
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component
export default class Badge extends Vue {
  @Prop({default: 'example'})
  private value: string;
  @Prop({default: false})
  private enableRemove: boolean;

  constructor() {
    super();
  }

  @Emit('close')
  private onClose(value: string) {
    //
  }
}
